import React, { useEffect, useState } from 'react';
import axios from 'axios';
import configApi from '../../config';

const TopCustomers = () => {
    const [customers, setCustomers] = useState([]);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${configApi.apiEndpoint}/api/Stats/TopCustomers`,
                    config
                );
                setCustomers(response.data);
            } catch (error) {
                console.error('Error fetching top customers:', error);
            }
        };
        fetchData();
    }, []);

    return (
        <div className="card-custom">
            <div className="card-custom-header">
                <h5>Top zákazníci</h5>
            </div>
            {customers.length > 0 ? (
                <div className="table-responsive mt-2">
                    <table className="table table-hover table-sm">
                        <thead style={{ backgroundColor: 'var(--argentinian-blue)', color: 'white' }}>
                            <tr>
                                <th>Zákazník</th>
                                <th>Termíny</th>
                                <th>Tržba</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customers.map((customer, index) => (
                                <tr key={index}>
                                    <td className="fw-bold">{customer.fullName}</td>
                                    <td>{customer.count}x</td>
                                    <td className="text-success fw-bold">{customer.revenueGenerated || 0} €</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p className="p-3 text-muted">Nie sú dostupné žiadne údaje o zákazníkoch.</p>
            )}
        </div>
    );
};

export default TopCustomers;
